import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { SelectInstitutionComponent } from './select-institution/select-institution.component';
import { ConfirmResetComponent } from './confirm-reset/confirm-reset.component';
import { AuthGuardService } from './services/auth-guard.service';
import { CustomerResolveService } from './services/customer-resolve.service';
import { ResetPasswordGuardService } from './services/reset-password-guard.service';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';
import { DeepLinkGuardService } from './services/deep-link-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ DeepLinkGuardService ]
  },
  {
    path: 'reset-password',
    component: ResetComponent
  },
  {
    path: 'select-institution',
    component: SelectInstitutionComponent,
    canActivate: [ AuthGuardService ],
    resolve: {
      customers: CustomerResolveService
    }
  },
  {
    path: 'auth/confirm-reset/:token',
    component: ConfirmResetComponent,
    canActivate: [ ResetPasswordGuardService ]
  },
  {
    path: 'expired-link',
    component: ExpiredLinkComponent
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})

export class AuthRoutingModule { }
